<template>
  <div class="mt-8 px-5">
    <!-- Header -->
    <v-card flat class="mb-0">
      <div class="px-6 py-4">
        <div class="d-flex align-center justify-space-between w-100">
          <div>
            <h1 class="fs-18 font-weight-bold mb-1">Tracking Driver</h1>
            <p class="fs-14 text--secondary mb-0">
              Pantau lokasi driver secara real-time
            </p>
          </div>
          <div class="d-flex align-center">
            <v-chip
              :color="selectedDrivers.length > 0 ? 'success' : 'grey'"
              text-color="white"
              small
              class="mr-3"
            >
              {{ selectedDrivers.length }} Driver Dipilih
            </v-chip>
            <v-btn
              color="primary"
              elevation="0"
              small
              @click="loadDummyData"
              :loading="loading"
              class="text-capitalize"
            >
              <v-icon left>mdi-refresh</v-icon>
              Refresh
            </v-btn>
          </div>
        </div>
      </div>
    </v-card>

    <!-- Main Content -->
    <v-row class="h-100">
      <!-- Driver List Sidebar -->
      <v-col cols="12" md="4" lg="3" class="h-100 pr-0">
        <v-card flat class="h-100" style="border-radius: 0;">
          <div class="px-4 py-3">
            <div class="d-flex align-center justify-space-between w-100">
              <span class="fs-14">Daftar Driver</span>
              <v-btn
                icon
                small
                @click="toggleSelectAll"
                :color="allSelected ? 'primary' : 'grey'"
              >
                <v-icon>{{ allSelected ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}</v-icon>
              </v-btn>
            </div>
          </div>
          <!-- <div style="height: 70vh; min-height: 400px;" v-if="loading"> -->
          <!-- </div> -->
          <v-card-text class="pa-0">
            <v-list dense class="pa-0" style="height: 70vh; overflow-y: auto; min-height: 400px;">
              <div v-if="loading">
                <div v-for="i in 10" :key="i">
                  <v-skeleton-loader
                    type="list-item-avatar"
                  ></v-skeleton-loader>
                </div>
              </div>
              <v-list-item
                v-for="driver in drivers"
                :key="driver.driver_id"
                @click="toggleDriverSelection(driver)"
                :class="[
                  'driver-item',
                  { 'selected-driver': isDriverSelected(driver) }
                ]"
                class="px-2 py-1"
              >
                <v-list-item-avatar size="30" class="mr-3">
                  <v-avatar
                    :color="isDriverSelected(driver) ? 'primary' : 'grey lighten-2'"
                    size="30"
                  >
                    <v-icon
                      :color="isDriverSelected(driver) ? 'white' : 'grey'"
                      size="20"
                    >
                      mdi-account
                    </v-icon>
                  </v-avatar>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title class="font-weight-medium">
                    {{ driver.driver_name }}
                  </v-list-item-title>
                  <!-- <v-list-item-subtitle class="text-caption">
                    ID: {{ driver.driver_id }}
                  </v-list-item-subtitle> -->
                  <div class="d-flex align-center mt-1">
                    <!-- <v-chip
                      :color="getDriverStatusColor(driver)"
                      text-color="white"
                      x-small
                      class="mr-2"
                    >
                      {{ getDriverStatus(driver) }}
                    </v-chip> -->
                    <span class="text-caption text--secondary">
                      {{ formatDateTime(driver.create_datetime) }}
                    </span>
                  </div>
                </v-list-item-content>

                <v-list-item-action>
                  <v-checkbox
                    :input-value="isDriverSelected(driver)"
                    :color="isDriverSelected(driver) ? 'primary' : 'grey'"
                    hide-details
                    @click.stop="toggleDriverSelection(driver)"
                  ></v-checkbox>
                </v-list-item-action>
              </v-list-item>
            </v-list>

            <!-- No drivers message -->
            <div v-if="drivers.length === 0" class="text-center py-8">
              <v-icon size="48" color="grey lighten-1" class="mb-3">mdi-account-off</v-icon>
              <div class="text-h6 text--secondary mb-2">Tidak Ada Driver</div>
              <div class="text-body-2 text--secondary">Belum ada data driver yang tersedia</div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Map Section -->
      <v-col cols="12" md="8" lg="9" class="h-100 pl-0">
        <v-card flat class="h-100" style="border-radius: 0;">
          <div class="px-4 py-3">
            <v-row>
              <v-col cols="12" sm="12" md="6">
                <span class="fs-14">
                  Map Tracking
                  <v-chip
                    v-if="autoCenterEnabled"
                    x-small
                    color="success"
                    text-color="white"
                    class="ml-2"
                  >
                    <v-icon left x-small>mdi-crosshairs-gps</v-icon>
                    Auto Follow
                  </v-chip>
                </span>
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <div v-if="selectedDrivers.length > 0" class="d-flex align-center justify-end">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        :color="autoCenterEnabled ? 'success' : 'grey'"
                        outlined
                        @click="toggleAutoCenter"
                        :class="rps !== 'xs' ? 'mr-2' : 'mr-1'"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon left>{{ autoCenterEnabled ? 'mdi-crosshairs-gps' : 'mdi-crosshairs-gps-off' }}</v-icon>
                        {{ autoCenterEnabled ? 'Auto Center ON' : 'Auto Center OFF' }}
                      </v-btn>
                    </template>
                    <span>{{ autoCenterEnabled ? 'Peta akan otomatis mengikuti posisi driver' : 'Peta tidak akan otomatis bergerak' }}</span>
                  </v-tooltip>
                  <v-btn
                    small
                    color="primary"
                    outlined
                    @click="centerOnSelectedDrivers"
                    class="mr-2"
                  >
                    <v-icon left>mdi-crosshairs-gps</v-icon>
                    Center Map
                  </v-btn>
                  <!-- <v-btn
                    icon
                    :small="rps !== 'xs'"
                    :x-small="rps === 'xs'"
                    @click="toggleFullScreen"
                  >
                    <v-icon>mdi-fullscreen</v-icon>
                  </v-btn> -->
                </div>
              </v-col>
            </v-row>
          </div>
          <v-card-text class="pa-0">
            <div v-if="selectedDrivers.length === 0 && !loading" class="text-center py-12">
              <v-icon size="64" color="grey lighten-1" class="mb-4">mdi-map-marker-off</v-icon>
              <div class="text-h6 text--secondary mb-2">Pilih Driver</div>
              <div class="text-body-2 text--secondary">
                Pilih driver dari daftar untuk melihat posisi terakhir
              </div>
            </div>

            <div v-else>
              <div 
                :class="['map-container', { 'fullscreen-map': isFullScreen }]" 
                style="height: 70vh; min-height: 400px;"
              >
                <v-overlay :value="loading" absolute>
                  <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
                </v-overlay>
                <gmap-map
                  :center="mapCenter"
                  :zoom="15"
                  :options="{
                    zoomControl: true,
                    mapTypeControl: false,
                    scaleControl: false,
                    streetViewControl: false,
                    rotateControl: false,
                    fullscreenControl: false,
                    disableDefaultUi: false
                  }"
                  style="width: 100%; height: 100%;"
                  @idle="onMapIdle"
                  ref="gmap"
                >
                  <!-- Markers for selected drivers -->
                  <gmap-marker
                    v-for="driver in selectedDrivers"
                    :key="driver.driver_id"
                    :position="{ lat: driver.latitude, lng: driver.longitude }"
                    :icon="{
                      url: require('@/assets/icon/distribution.png'),
                      scaledSize: {width: 40, height: 40}
                    }"
                    :title="driver.driver_name"
                    @click="setActiveDriver(driver)"
                  >
                    <!-- Info window for each marker -->
                    <gmap-info-window
                      :options="{
                        pixelOffset: { width: 0, height: -40 }
                      }"
                      @closeclick="activeDriver = null"
                    >
                      <div class="driver-info-window">
                        <div class="d-flex align-center mb-2">
                          <v-avatar color="primary" size="32" class="mr-3">
                            <v-icon color="white" size="16">mdi-account</v-icon>
                          </v-avatar>
                          <div>
                            <div class="text-subtitle-2 font-weight-medium">
                              {{ driver.driver_name }}
                            </div>
                            <div class="text-caption text--secondary">
                              ID: {{ driver.driver_id }}
                            </div>
                          </div>
                        </div>
                        <div class="mb-2">
                          <div class="text-caption text--secondary mb-1">Lokasi</div>
                          <div class="text-body-2">
                            {{ driver.latitude.toFixed(6) }}, {{ driver.longitude.toFixed(6) }}
                          </div>
                        </div>
                        <div class="mb-2">
                          <div class="text-caption text--secondary mb-1">Status</div>
                          <v-chip
                            :color="getDriverStatusColor(driver)"
                            text-color="white"
                            x-small
                          >
                            {{ getDriverStatus(driver) }}
                          </v-chip>
                        </div>
                        <div>
                          <div class="text-caption text--secondary mb-1">Update Terakhir</div>
                          <div class="text-body-2">
                            {{ formatDateTime(driver.create_datetime) }}
                          </div>
                        </div>
                        <div class="mt-2">
                          <v-chip
                            :color="autoCenterEnabled ? 'success' : 'grey'"
                            text-color="white"
                            x-small
                          >
                            <v-icon left x-small>{{ autoCenterEnabled ? 'mdi-crosshairs-gps' : 'mdi-crosshairs-gps-off' }}</v-icon>
                            {{ autoCenterEnabled ? 'Auto Follow ON' : 'Auto Follow OFF' }}
                          </v-chip>
                        </div>
                      </div>
                    </gmap-info-window>
                  </gmap-marker>
                </gmap-map>

                <!-- Driver Info Panel -->
                <div v-if="activeDriver" class="floating-info-panel">
                  <v-card flat>
                    <v-card-title class="px-4 py-3" style="width: 100%;">
                      <div class="d-flex align-center">
                        <v-avatar color="primary" size="32" class="mr-3">
                          <div v-if="!process.detail && detailDriver">
                            <img v-if="detailDriver.image_url == ''" :src="require('@/assets/icon/profile-color.png')" alt="driver" style="width: 100%; height: 100%; object-fit: cover;">
                            <img v-else :src="detailDriver.image_url" alt="driver" style="width: 100%; height: 100%; object-fit: cover;">
                          </div>
                          <v-icon v-if="!process.detail && !detailDriver" color="white" size="16">mdi-account</v-icon>
                        </v-avatar>
                        <div>
                          <div class="text-subtitle-1 font-weight-medium">
                            {{ activeDriver.driver_name }}
                          </div>
                          <div class="text-caption text--secondary">
                            <div v-if="detailDriver">
                              {{ detailDriver.email }}
                            </div>
                            <div v-else>
                              <v-skeleton-loader type="text" width="100%" height="10px"></v-skeleton-loader>
                            </div>
                          </div>
                        </div>
                        <div style="position: absolute; top: 5px; right: 5px;">
                          <v-btn icon small color="red" @click="deleteDriver(activeDriver.driver_id)">
                            <v-icon>mdi-close-circle</v-icon>
                          </v-btn>
                        </div>
                      </div>
                    </v-card-title>
                    <v-card-text class="px-4 pb-3">
                      <!-- <div class="mb-3">
                        <div class="text-caption text--secondary mb-1">Lokasi</div>
                        <div class="text-body-2">
                          {{ activeDriver.latitude.toFixed(6) }}, {{ activeDriver.longitude.toFixed(6) }}
                        </div>
                      </div>
                      <div class="mb-3">
                        <div class="text-caption text--secondary mb-1">Status</div>
                        <v-chip
                          :color="getDriverStatusColor(activeDriver)"
                          text-color="white"
                          x-small
                        >
                          {{ getDriverStatus(activeDriver) }}
                        </v-chip>
                      </div> -->
                      <!-- <div class="text-caption grey--text text--darken-4 mb-2">
                        <div class="text-caption">Kode Driver (Area Driver)</div>
                        <div v-if="detailDriver">
                          {{ detailDriver.driver_region_name }}
                        </div>
                        <div v-else>
                          <v-skeleton-loader type="text" width="100%" height="10px"></v-skeleton-loader>
                        </div>
                      </div> -->
                      <div class="text-caption grey--text text--darken-4 mb-2">
                        <div class="text-caption">No. Handphone</div>
                        <div v-if="detailDriver">
                          {{ detailDriver.mobilephone }}
                        </div>
                        <div v-else>
                          <v-skeleton-loader type="text" width="100%" height="10px"></v-skeleton-loader>
                        </div>
                      </div>
                      <div class="text-caption grey--text text--darken-4 mb-2">
                        <div class="text-caption">Surat Jalan</div>
                        <div v-if="suratJalan">
                          <div v-for="(surat, index) in suratJalan" :key="surat.id">
                            <div class="text-caption mb-1">
                              <div>
                                <div class="text-caption">
                                  <a :href="`/delivery/surat-jalan/detail/${surat.id}`" target="_blank">
                                    <div>
                                      {{ surat.number }} ({{ surat.total_bpb }} BPB)
                                    </div>
                                  </a>
                                  <div class="fs-11" style="margin-top: -5px;">
                                    {{ surat.vehicle_name }} - {{ surat.vehicle_number }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div v-else>
                          <v-skeleton-loader type="text" width="100%" height="10px"></v-skeleton-loader>
                        </div>
                      </div>

                      <div class="text-caption grey--text text--darken-4">
                        <div class="text-caption">Update Terakhir</div>
                        <div class="">
                          {{ activeDriver.create_datetime | datetime }}
                        </div>
                      </div>
                      <div class="mt-2">
                        <v-chip
                          :color="autoCenterEnabled ? 'success' : 'grey'"
                          text-color="white"
                          x-small
                        >
                          <v-icon left x-small>{{ autoCenterEnabled ? 'mdi-crosshairs-gps' : 'mdi-crosshairs-gps-off' }}</v-icon>
                          {{ autoCenterEnabled ? 'Auto Follow ON' : 'Auto Follow OFF' }}
                        </v-chip>
                      </div>
                    </v-card-text>
                  </v-card>
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    
    <!-- Snackbar for notifications -->
    <v-snackbar
      v-model="showSnackbar"
      :color="snackbarColor"
      :timeout="3000"
      top
    >
      {{ snackbarMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="showSnackbar = false"
        >
          Tutup
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { get, post, put, patch, destroy } from "@/service/Axios";

export default {
  name: 'DriverTracking',
  data() {
    return {
      loading: false,
      drivers: [],
      selectedDrivers: [],
      activeDriver: null,
      isFullScreen: false,
      mapReady: false,
      unsubscribeDriverListener: null, // Tambah untuk simpan unsubscribe
      autoCenterEnabled: true, // Kontrol untuk auto-center map
      autoCenterTimeout: null, // Untuk debounce auto-center
      showSnackbar: false,
      snackbarMessage: '',
      snackbarColor: 'success',
      lastNotificationTime: 0, // Untuk mencegah notifikasi terlalu sering
      detailDriver: null,
      suratJalan: [],
      process: {
        detail: false,
        suratJalan: false
      }
    }
  },
  computed: {
    rps () {
      return this.$vuetify.breakpoint.name
    },
    mapCenter() {
      if (this.selectedDrivers.length > 0) {
        return {
          lat: this.selectedDrivers[0].latitude,
          lng: this.selectedDrivers[0].longitude
        }
      }
      return { lat: -6.2088, lng: 106.8456 } // Default to Jakarta
    },
    allSelected() {
      return this.drivers.length > 0 && this.selectedDrivers.length === this.drivers.length
    }
  },
  mounted() {
    // Load auto-center preference from localStorage
    const savedAutoCenter = localStorage.getItem('driverTrackingAutoCenter')
    if (savedAutoCenter !== null) {
      this.autoCenterEnabled = savedAutoCenter === 'true'
    } else {
      // Show notification for first time auto-center setting
      this.snackbarMessage = 'Auto-center diaktifkan secara default - Peta akan mengikuti posisi driver'
      this.snackbarColor = 'info'
      this.showSnackbar = true
    }
    
    // this.loadDummyData() // Tidak perlu lagi jika pakai realtime
    this.listenToDriverRealtime()
    this.waitForGoogleMaps()
    
    // Show welcome notification
    this.snackbarMessage = 'Selamat datang di Tracking Driver - Pilih driver untuk mulai tracking'
    this.snackbarColor = 'info'
    this.showSnackbar = true
  },
  destroyed() {
    if (this.unsubscribeDriverListener) {
      this.unsubscribeDriverListener()
    }
    if (this.autoCenterTimeout) {
      clearTimeout(this.autoCenterTimeout)
    }
  },
  methods: {
    deleteDriver(id) {
      this.activeDriver = null
    },
    listenToDriverRealtime() {
      this.loading = true
      const { setupRealtimeListener } = require('@/plugins/Firebase.js')
      this.unsubscribeDriverListener = setupRealtimeListener(
        'tracking_driver',
        (driverData) => {
          this.drivers = driverData.map(driver => ({
            ...driver,
            latitude: parseFloat(driver.latitude),
            longitude: parseFloat(driver.longitude),
          }))
          // Auto-select first driver by default
          if (this.drivers.length > 0 && this.selectedDrivers.length === 0) {
            this.selectedDrivers = [this.drivers[0]]
            this.activeDriver = this.drivers[0]
            this.fetchDetail(this.activeDriver.driver_id)
            // Show notification for initial data load
            this.snackbarMessage = `Data driver dimuat - ${this.drivers.length} driver tersedia`
            this.snackbarColor = 'info'
            this.showSnackbar = true
          } else if (this.selectedDrivers.length > 0) {
            this.selectedDrivers = this.selectedDrivers.map(selected => {
              const updated = this.drivers.find(d => d.driver_id === selected.driver_id)
              return updated || selected
            })
            if (this.activeDriver == null) {
              // this.activeDriver = this.selectedDrivers[0]
              // this.fetchDetail(this.activeDriver.driver_id)
            } else {
              this.activeDriver = this.drivers.find(d => d.driver_id === this.activeDriver.driver_id) || this.activeDriver
              this.fetchDetail(this.activeDriver.driver_id)
            }
          } else if (this.drivers.length === 0) {
            // Show notification for no data in realtime
            this.snackbarMessage = 'Tidak ada data driver realtime yang tersedia'
            this.snackbarColor = 'warning'
            this.showSnackbar = true
          }
          this.waitForGoogleMaps()
          this.loading = false
          
          // Show success notification for realtime data
          if (this.drivers.length > 0) {
            this.snackbarMessage = `Data realtime berhasil dimuat - ${this.drivers.length} driver aktif`
            this.snackbarColor = 'success'
            this.showSnackbar = true
          }
          
          // Auto-center map when data updates (with debounce)
          if (this.autoCenterTimeout) {
            clearTimeout(this.autoCenterTimeout)
          }
          this.autoCenterTimeout = setTimeout(() => {
            this.autoCenterMapOnUpdate()
            // Show notification for data update (but not too frequently)
            const now = Date.now()
            if (this.autoCenterEnabled && this.selectedDrivers.length > 0 && (now - this.lastNotificationTime) > 10000) {
              this.snackbarMessage = `Data posisi driver diperbarui - ${this.selectedDrivers.length} driver dipantau`
              this.snackbarColor = 'info'
              this.showSnackbar = true
              this.lastNotificationTime = now
            }
          }, 500) // Delay 500ms to prevent too frequent updates
        },
        (error) => {
          this.drivers = []
          this.selectedDrivers = []
          this.activeDriver = null
          this.loading = false
          // Show error notification
          this.snackbarMessage = 'Gagal memuat data driver - Silakan coba lagi'
          this.snackbarColor = 'error'
          this.showSnackbar = true
        }
      )
    },
    async loadDummyData() {
      this.loading = true
      this.drivers = []
      this.selectedDrivers = []
      this.activeDriver = null
      this.loading = true
      
      // Show notification for refresh
      this.snackbarMessage = 'Memperbarui data driver...'
      this.snackbarColor = 'info'
      this.showSnackbar = true
      try {
        // Fetch from Firebase REST API (same as testRestAPI in firebase-test.vue)
        const url = `https://firestore.googleapis.com/v1/projects/megavin-2024/databases/megavin/documents/tracking_driver?key=AIzaSyBOPTtkIgtVgu2bMgCZ9aMsOKXblsegtdg`
        const response = await fetch(url)
        if (!response.ok) throw new Error(`HTTP ${response.status}: ${response.statusText}`)
        const data = await response.json()
        if (data.documents && data.documents.length > 0) {
          const parsedData = data.documents.map(doc => {
            const fields = doc.fields || {}
            return {
              id: doc.name.split('/').pop(),
              driver_id: this.extractValue(fields.driver_id),
              driver_name: this.extractValue(fields.driver_name),
              latitude: parseFloat(this.extractValue(fields.latitude)),
              longitude: parseFloat(this.extractValue(fields.longitude)),
              create_datetime: this.extractValue(fields.create_datetime)
            }
          })
          this.drivers = parsedData
          // Auto-select first driver by default
          if (this.drivers.length > 0) {
            this.selectedDrivers = [this.drivers[0]]
            this.activeDriver = this.drivers[0]
            // Show success notification
            this.snackbarMessage = `Data berhasil diperbarui - ${this.drivers.length} driver ditemukan`
            this.snackbarColor = 'success'
            this.showSnackbar = true
            this.fetchDetail(this.drivers[0].driver_id)
          }
          } else {
            this.drivers = []
            this.selectedDrivers = []
            this.activeDriver = null
            // Show notification for no data
            this.snackbarMessage = 'Tidak ada data driver yang tersedia'
            this.snackbarColor = 'warning'
            this.showSnackbar = true
          }
      } catch (error) {
        this.drivers = []
        this.selectedDrivers = []
        this.activeDriver = null
        // Show error notification
        this.snackbarMessage = `Gagal memperbarui data: ${error.message}`
        this.snackbarColor = 'error'
        this.showSnackbar = true
      } finally {
        this.loading = false
      }
    },

    async fetchDetail (id) {
      this.process.detail = true
      let params = {
          id: id
        }

        await get('admin/user/detail', { params })
      .then(response => {
        let res = response.data

        this.process.detail = false
          
        if (res.status === 200) {
          this.detailDriver = res.results.data
          this.fetchSuratJalan(id)
        }
      })
    },

    async fetchSuratJalan (driver_id) {
      this.process.suratJalan = true
      let params = {
        status: 'pengiriman',
          driver_id: driver_id,
          limit: 1000,
          page: 1,
          sort: 'id'
        }

        await get('admin/surat_jalan/data', { params })
      .then(response => {
        let res = response.data

        this.process.suratJalan = false
          
        if (res.status === 200) {
          this.suratJalan = res.results.data
        }
      })
    },
    
    refreshData() {
      this.loading = true
      
      // Simulate refresh with slight data changes
      setTimeout(() => {
        this.drivers = this.dummyDrivers.map(driver => ({
          ...driver,
          latitude: driver.latitude + (Math.random() - 0.5) * 0.01,
          longitude: driver.longitude + (Math.random() - 0.5) * 0.01,
          create_datetime: new Date().toISOString().slice(0, 19).replace('T', ' ')
        }))
        
        // Update selected drivers with new data
        this.selectedDrivers = this.selectedDrivers.map(selected => {
          const updated = this.drivers.find(d => d.driver_id === selected.driver_id)
          return updated || selected
        })
        
        if (this.activeDriver) {
          this.activeDriver = this.drivers.find(d => d.driver_id === this.activeDriver.driver_id) || this.activeDriver
        }
        
        this.loading = false
      }, 1500)
    },
    
    toggleDriverSelection(driver) {
      const index = this.selectedDrivers.findIndex(d => d.driver_id === driver.driver_id)
      
      if (index === -1) {
        this.selectedDrivers.push(driver)
        // Show notification for selecting driver
        this.snackbarMessage = `Driver "${driver.driver_name}" ditambahkan`
        this.snackbarColor = 'success'
        this.showSnackbar = true
      } else {
        this.selectedDrivers.splice(index, 1)
        // Show notification for deselecting driver
        this.snackbarMessage = `Driver "${driver.driver_name}" dibatalkan`
        this.snackbarColor = 'warning'
        this.showSnackbar = true
      }

      this.activeDriver = null
      
      // Set active driver to the last selected
      // this.activeDriver = this.selectedDrivers[this.selectedDrivers.length - 1]
      // this.fetchDetail(this.activeDriver.driver_id)
      
      // Center map on the newly selected driver
      this.$nextTick(() => {
        if (this.autoCenterEnabled) {
          this.autoCenterMapOnUpdate()
          // Show notification for selection
          this.snackbarMessage = `Driver "${driver.driver_name}" dipilih - Auto follow aktif`
          this.snackbarColor = 'success'
          this.showSnackbar = true
        } else {
          this.centerOnDriver(this.selectedDrivers[this.selectedDrivers.length - 1])
          // Show notification for selection
          this.snackbarMessage = `Driver "${driver.driver_name}" dipilih - Auto follow nonaktif`
          this.snackbarColor = 'info'
          this.showSnackbar = true
        }
      })
    },
    
    isDriverSelected(driver) {
      return this.selectedDrivers.some(d => d.driver_id === driver.driver_id)
    },
    
    toggleSelectAll() {
      if (this.allSelected) {
        this.selectedDrivers = []
        this.activeDriver = null
        // Show notification for deselecting all
        this.snackbarMessage = 'Semua driver dibatalkan'
        this.snackbarColor = 'warning'
        this.showSnackbar = true
      } else {
        this.selectedDrivers = [...this.drivers]
        this.activeDriver = null
        // this.fetchDetail(this.activeDriver.driver_id)
        // Auto-center when selecting all
        this.$nextTick(() => {
          if (this.autoCenterEnabled) {
            this.autoCenterMapOnUpdate()
            // Show notification for selecting all
            this.snackbarMessage = `Semua driver dipilih (${this.drivers.length}) - Auto follow aktif`
            this.snackbarColor = 'success'
            this.showSnackbar = true
          } else {
            // Show notification for selecting all
            this.snackbarMessage = `Semua driver dipilih (${this.drivers.length}) - Auto follow nonaktif`
            this.snackbarColor = 'info'
            this.showSnackbar = true
          }
        })
      }
    },
    
    setActiveDriver(driver) {
      this.activeDriver = driver
      this.fetchDetail(driver.driver_id)
      
      // Show notification for changing active driver
      this.snackbarMessage = `Driver "${driver.driver_name}" menjadi aktif`
      this.snackbarColor = 'info'
      this.showSnackbar = true
    },
    
    centerOnDriver(driver) {
      if (this.$refs.gmap && this.$refs.gmap.panTo) {
        this.$refs.gmap.panTo({ lat: driver.latitude, lng: driver.longitude })
        
        // Show notification for centering on specific driver
        this.snackbarMessage = `Peta di-center ke posisi ${driver.driver_name}`
        this.snackbarColor = 'info'
        this.showSnackbar = true
      }
    },
    
    centerOnSelectedDrivers() { 
      if (this.selectedDrivers.length > 0 && this.$refs.gmap) {
        const bounds = new google.maps.LatLngBounds()
        
        this.selectedDrivers.forEach(driver => {
          bounds.extend({ lat: driver.latitude, lng: driver.longitude })
        })
        
        this.$refs.gmap.fitBounds(bounds)
        
        // Show notification for manual center
        this.snackbarMessage = `Peta di-center ke ${this.selectedDrivers.length} driver yang dipilih`
        this.snackbarColor = 'info'
        this.showSnackbar = true
      }
    },
    
    autoCenterMapOnUpdate() {
      // Auto-center map when data updates in realtime
      if (this.autoCenterEnabled && this.selectedDrivers.length > 0 && this.$refs.gmap && this.mapReady) {
        // If only one driver selected, center on that driver
        if (this.selectedDrivers.length === 1) {
          const driver = this.selectedDrivers[0]
          this.$refs.gmap.panTo({ lat: driver.latitude, lng: driver.longitude })
        } else {
          // If multiple driver selected, fit bounds to show all
          const bounds = new google.maps.LatLngBounds()
          this.selectedDrivers.forEach(driver => {
            bounds.extend({ lat: driver.latitude, lng: driver.longitude })
          })
          this.$refs.gmap.fitBounds(bounds)
        }
      }
    },
    
    toggleFullScreen() {
      this.isFullScreen = !this.isFullScreen
      
      this.$nextTick(() => {
        if (this.isFullScreen) {
          document.body.style.overflow = 'hidden'
          // Show notification for fullscreen
          this.snackbarMessage = 'Mode fullscreen diaktifkan'
          this.snackbarColor = 'info'
          this.showSnackbar = true
        } else {
          document.body.style.overflow = ''
          // Show notification for exiting fullscreen
          this.snackbarMessage = 'Mode fullscreen dinonaktifkan'
          this.snackbarColor = 'info'
          this.showSnackbar = true
        }
      })
    },
    
    toggleAutoCenter() {
      this.autoCenterEnabled = !this.autoCenterEnabled
      // Save preference to localStorage
      localStorage.setItem('driverTrackingAutoCenter', this.autoCenterEnabled.toString())
      
      // Show notification
      const message = this.autoCenterEnabled ? 
        'Auto-center diaktifkan - Peta akan mengikuti posisi driver' : 
        'Auto-center dinonaktifkan - Peta tidak akan bergerak otomatis'
      
      // If turning on auto-center, immediately center the map
      if (this.autoCenterEnabled) {
        this.$nextTick(() => {
          this.autoCenterMapOnUpdate()
        })
      }
      
      // Show snackbar notification
      this.snackbarMessage = message
      this.snackbarColor = this.autoCenterEnabled ? 'success' : 'info'
      this.showSnackbar = true
    },
    
    getDriverStatus(driver) {
      const lastUpdate = new Date(driver.create_datetime)
      const now = new Date()
      const diffMinutes = (now - lastUpdate) / (1000 * 60)
      
      if (diffMinutes <= 5) return 'Online'
      if (diffMinutes <= 15) return 'Active'
      return 'Offline'
    },
    
    getDriverStatusColor(driver) {
      const status = this.getDriverStatus(driver)
      switch (status) {
        case 'Online': return 'success'
        case 'Active': return 'warning'
        default: return 'grey'
      }
    },
    
    getDriverMarkerIcon(driver) {
      const status = this.getDriverStatus(driver)
       let iconUrl = ''
       
       switch (status) {
         case 'Online':
           iconUrl = 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(`
             <svg width="40" height="40" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
               <circle cx="20" cy="20" r="18" fill="#4CAF50" stroke="#fff" stroke-width="3"/>
               <circle cx="20" cy="20" r="8" fill="#fff"/>
               <circle cx="20" cy="20" r="4" fill="#4CAF50"/>
               <text x="20" y="35" text-anchor="middle" fill="#fff" font-size="10" font-weight="bold">${driver.driver_name.charAt(0)}</text>
             </svg>
           `)
           break
         case 'Active':
           iconUrl = 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(`
             <svg width="40" height="40" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
               <circle cx="20" cy="20" r="18" fill="#FF9800" stroke="#fff" stroke-width="3"/>
               <circle cx="20" cy="20" r="8" fill="#fff"/>
               <circle cx="20" cy="20" r="4" fill="#FF9800"/>
               <text x="20" y="35" text-anchor="middle" fill="#fff" font-size="10" font-weight="bold">${driver.driver_name.charAt(0)}</text>
             </svg>
           `)
           break
         default:
           iconUrl = 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(`
             <svg width="40" height="40" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
               <circle cx="20" cy="20" r="18" fill="#9E9E9E" stroke="#fff" stroke-width="3"/>
               <circle cx="20" cy="20" r="8" fill="#fff"/>
               <circle cx="20" cy="20" r="4" fill="#9E9E9E"/>
               <text x="20" y="35" text-anchor="middle" fill="#fff" font-size="10" font-weight="bold">${driver.driver_name.charAt(0)}</text>
             </svg>
           `)
       }
       
       return {
         url: iconUrl,
         scaledSize: { width: 40, height: 40 },
         anchor: { x: 20, y: 40 }
       }
     },
    
    formatDateTime(dateTimeString) {
      const date = new Date(dateTimeString)
      return date.toLocaleString('id-ID', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })
    },
    
    onMapIdle() {
      this.mapReady = true
      
      // Show notification when map is ready
      if (!this.mapReady) {
        this.snackbarMessage = 'Peta siap untuk tracking'
        this.snackbarColor = 'success'
        this.showSnackbar = true
      }
    },
    
    waitForGoogleMaps() {
      if (window.google && window.google.maps) {
        this.mapReady = true
        
        // Show notification when Google Maps is ready
        this.snackbarMessage = 'Google Maps siap untuk tracking'
        this.snackbarColor = 'success'
        this.showSnackbar = true
      } else {
        setTimeout(() => {
          this.waitForGoogleMaps()
        }, 100)
      }
    },

    extractValue(field) {
      if (!field) return 'N/A'
      if (typeof field === 'object') {
        if (field.stringValue) return field.stringValue
        if (field.integerValue) return field.integerValue.toString()
        if (field.doubleValue) return field.doubleValue.toString()
        if (field.booleanValue !== undefined) return field.booleanValue.toString()
        if (field.timestampValue) return field.timestampValue
        if (field.nullValue !== undefined) return 'N/A'
      }
      if (typeof field === 'string') return field
      if (typeof field === 'number') return field.toString()
      if (typeof field === 'boolean') return field.toString()
      return 'N/A'
    }
  }
}
</script>

<style scoped>
.driver-item {
  cursor: pointer;
  transition: background-color 0.2s ease;
  border-radius: 8px;
  margin: 2px 8px;
}

.driver-item:hover {
  background-color: #f5f5f5;
}

.selected-driver {
  background-color: #e3f2fd !important;
  border-left: 4px solid #1976d2;
}

.map-container {
  position: relative;
  height: 70vh;
  min-height: 400px;
}

.floating-info-panel {
  position: absolute;
  top: 16px;
  left: 16px;
  z-index: 2;
  min-width: 280px;
  max-width: 320px;
}

.fullscreen-map {
  position: fixed !important;
  top: 0;
  left: 0;
  width: 100vw !important;
  height: 100vh !important;
  min-height: 100vh !important;
  z-index: 9999;
  background: #fff;
}

.h-100 {
  height: 100%;
}

/* Custom styles for better UI */
.v-card {
  border-radius: 8px;
}

.v-list-item {
  border-radius: 4px;
  margin: 2px 8px;
}

.v-chip {
  font-weight: 500;
}

 /* Responsive adjustments */
 @media (max-width: 960px) {
   .floating-info-panel {
     position: relative;
     top: auto;
     left: auto;
     margin: 16px;
     max-width: none;
   }
 }

 /* Info window styling */
 .driver-info-window {
   padding: 8px;
   min-width: 250px;
   max-width: 300px;
 }

 .driver-info-window .v-chip {
   font-size: 10px;
   height: 20px;
 }

 .driver-info-window .text-body-2 {
   font-size: 12px;
   line-height: 1.4;
 }

 .driver-info-window .text-caption {
   font-size: 10px;
   line-height: 1.2;
 }
 
 /* Auto-center indicator */
 .v-chip--x-small {
   font-size: 10px !important;
   height: 20px !important;
 }
 
 /* Smooth transitions for map movements */
 .map-container {
   transition: all 0.3s ease;
 }
</style>
